import FcInputNumber from './FcInputNumber';

export default (Vue) => {
    Vue.component('FcInputNumber', FcInputNumber);
};



// WEBPACK FOOTER //
// ./src/components/FcInputNumber/index.js